export default __webpack_public_path__ + "static/6917-8dec5234924383e21995101f6c31c771.jpg";